import { VisualisationContextProps } from 'widgets/supportVisualisation/Content/VisualisationContentProps';
import React from 'react';

import './SupportVisualisationAvailabilityStatus.scss';
import { Grid } from '@instinet-analytics/semantic-ui-components';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { AvailabilityStatusUpdate } from 'app/store/connectivity/ConnectivityState';
import { GetRowClassParams } from '@instinet-analytics/semantic-ui-components';
import { selectAvailabilityStatusHistory } from 'app/store/connectivity/selectors';
import orderBy from 'lodash/orderBy';
import { toDateString } from 'widgets/supportVisualisation/SupportVisualisationHelpers';

export default function SupportVisualisationAvailabilityStatus(
    props: VisualisationContextProps
) {
    const { state } = props;

    const history = selectAvailabilityStatusHistory(state?.state);

    if (history.length === 0) {
        return <div>None found in state</div>;
    }

    const columnDefs = getColumns();

    const rowData = orderBy(history, ['timestamp'], ['desc']);

    return (
        <div className={'SupportVisualisationAvailabilityStatus'}>
            <Grid
                autoSizeColumns={true}
                singleSelectOnly={true}
                columnDefs={columnDefs}
                rowData={rowData}
                rowClassRules={getRowClassRules()}
                getRowDataId={(r) => r.timestamp.toString()}
            />
        </div>
    );
}

function getColumns(): ColDef[] {
    return [
        {
            field: 'timestamp',
            headerName: 'Time',
            resizable: true,
            width: 80,
            cellRenderer: (props: { value: number }) => {
                return <span>{toDateString(new Date(props.value))}</span>;
            },
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 140,
        },
        {
            field: 'available',
            headerName: 'Available?',
            sortable: true,
            resizable: true,
        },
    ];
}

function getRowClassRules() {
    return {
        available: (params: GetRowClassParams<AvailabilityStatusUpdate>) => {
            const item: AvailabilityStatusUpdate = params.data;
            return item.available;
        },
    };
}
